import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import {
  FitRelativeWrapper, AbsoluteRightTopWrapper,
  BorderedCard, FlexCenterWrapper, Mr2, Mt2,
  GenericWrapper, BorderBottomWrapper, Pb4, Mb2,
  Mt4, Width200, Mt1, HoverPrimary50BackgroundWrapper,
  CursorPointerWrapper, WhiteSpaceNoWrap
} from 'wrappers';
import React from 'react';
import internalState from './internalState';
import { ClickableIcon, NoteText, SecondaryTextXs300, SecondaryTextSm, Icon } from 'atoms';
import { MenuDotsSvg, EditPencilSvg, ClockSvg } from 'components/icons';
import { format } from 'date-fns';
import { getNoteText } from 'utils';

const dropdownRef = React.createRef();
const historyDropdownRef = React.createRef();

export const definition = {
  name: 'ActionsDropdown',
  controller: Controller,
  initialProps: ({ isEditable, event }) => ({ isEditable, event }),
  props: internalState,
  elements: [
    {
      component: ClickableIcon,
      name: 'Button',
      displayValue: ({ }) => MenuDotsSvg({}),
      bindings: ({ isOpen }) => ({ isOpen, dropdownRef }),
    },
    {
      wrapper: AbsoluteRightTopWrapper,
      name: 'Body',
      ref: dropdownRef,
      renderIf: ({ isOpen }) => isOpen,
      elements: [
        {
          wrapper: BorderedCard,
          displayState: ({ }) => ({ background: '#FFFFFF', borderRadius: '12px', padding: '0px' }),
          name: 'Wrapper',
          elements: [
            {
              wrapper: wrap(wrap(wrap(FlexCenterWrapper, HoverPrimary50BackgroundWrapper), CursorPointerWrapper), Mt2),
              name: 'Edit',
              isButton: true,
              renderIf: ({ isEditable }) => isEditable,
              bindings: ({ }) => ({}),
              elements: [
                {
                  component: wrap(Icon, Mr2),
                  name: 'Icon',
                  displayValue: ({ }) => EditPencilSvg({ width: 13, height: 13 })
                },
                {
                  component: SecondaryTextSm,
                  name: 'Text',
                  displayValue: ({ }) => 'Edit'
                }
              ]
            },
            {
              wrapper: wrap(wrap(wrap(FlexCenterWrapper, HoverPrimary50BackgroundWrapper), CursorPointerWrapper), Mb2),
              name: 'History',
              isButton: true,
              renderIf: ({ event }) => event?.description_history?.length > 0,
              bindings: ({ isOpenHistory }) => ({ isOpenHistory }),
              elements: [
                {
                  component: wrap(Icon, Mr2),
                  name: 'Icon',
                  displayValue: ({ }) => ClockSvg({ width: 13, height: 13 })
                },
                {
                  component: wrap(SecondaryTextSm, WhiteSpaceNoWrap),
                  name: 'Text',
                  displayValue: ({ }) => 'Version History'
                }
              ]
            },
            {
              wrapper: AbsoluteRightTopWrapper,
              name: 'HistoryBody',
              ref: historyDropdownRef,
              renderIf: ({ isOpenHistory }) => isOpenHistory,
              elements: [
                {
                  wrapper: BorderedCard,
                  displayState: ({ }) => ({ background: '#FFFFFF', borderRadius: '12px' }),
                  name: 'Wrapper',
                  elements: [
                    {
                      wrapper: wrap(wrap(wrap(GenericWrapper, Pb4), BorderBottomWrapper), Mt4),
                      name: 'Wrapper',
                      isListOf: { description: ({ event }) => event.description_history },
                      elements: [
                        {
                          component: wrap(NoteText, Width200),
                          name: 'NoteText',
                          displayValue: ({ description }) => {
                            return getNoteText(description?.description)
                          }
                        },
                        {
                          component: wrap(SecondaryTextXs300, Mt1),
                          name: 'Description',
                          displayValue: ({ description }) => description?.datetime ? format(description.datetime, 'MM/dd/yy hh:mm aa') : ""
                        },
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
      ]
    }
  ]
};

export default wrap(ContainerComponent(definition), FitRelativeWrapper);